import { BrowserRouter } from 'react-router-dom';
import AppProvider from '@/providers/index';

const App = function (): JSX.Element {
  return (
    <BrowserRouter>
      <AppProvider />
    </BrowserRouter>
  );
};

export default App;
